const MONTHS = {
    FULL: [
        'January', 'Febuary', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ],
    ABRV: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ],
};
const DAYS = [
    'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
];
// eslint-disable-next-line camelcase
function unix_to_mmm_dd_yyyy(unixTimestamp) {
    const timestamp = Number(unixTimestamp) || Date.now();
    const a = new Date(timestamp);
    const months = MONTHS.ABRV;
    const year = a.getFullYear();
    const month = months[a.getMonth()];
    const day = a.getDate();
    const friendlyDate = `${month} ${day}, ${year}`;
    return friendlyDate;
}
// eslint-disable-next-line camelcase
function unix_to_vue_date(unixTimestamp) {
    const timestamp = Number(unixTimestamp) || Date.now();
    const a = new Date(timestamp);
    const year = a.getFullYear();
    let month = a.getMonth();
    let day = a.getDate();
    month = month < 10 ? `0${month + 1}` : month;
    day = day < 10 ? `0${day}` : day;
    const friendlyDate = `${year}-${month}-${day}`;
    return friendlyDate;
}
function computeFullName(name) {
    name.fullName = `${name.firstName} ${name.lastName}`;
    return name.fullName;
}
export { MONTHS, 
// eslint-disable-next-line camelcase
unix_to_mmm_dd_yyyy, 
// eslint-disable-next-line camelcase
unix_to_vue_date, DAYS, computeFullName, };
// eslint-disable-next-line camelcase
// function name_str_2_obj(str:string):NameObj{
//     const splitString = str.split(" ");
//     const nameObj:NameObj = {
//         lastName: splitString.pop() || "",
//         firstName: splitString.join(" "),
//         fullName: str,
//     };
//     return nameObj;
// }
// eslint-disable-next-line camelcase
// function name_obj_2_str(nameObj:NameObj):string{
//     const nameString = nameObj.fullName || `${nameObj.firstName  } ${  nameObj.lastName}`;
//     return nameString;
// }
// eslint-disable-next-line camelcase
// function updateNameObj(field:string|symbol, input:string, ){}
//# sourceMappingURL=misc-functions.js.map